import cx from 'classnames'
import type { ReactNode } from 'react'
type Props = {
  title: string
  value: ReactNode | string
  className?: string
}
export const DocumentationEntry = ({ title, value, className }: Props) => (
  <>
    <div className="flex w-full flex-row items-center font-medium group-[.is-not-relevant]:opacity-20">
      {title}
    </div>
    <div className={cx('flex flex-col gap-y-2 w-full', className)}>{value}</div>
  </>
)
